import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { ProductType } from 'src/app/models/ProductType';
@Injectable({
    providedIn: 'root'
})
export class ProductTypeApi extends Api<ProductType> {
}
